import { render, staticRenderFns } from "./memberbalance-inner-balance.vue?vue&type=template&id=70ce5cec&"
import script from "./memberbalance-inner-balance.vue?vue&type=script&lang=js&"
export * from "./memberbalance-inner-balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports